import { render, staticRenderFns } from "./WebChat.vue?vue&type=template&id=58d52c41&scoped=true"
import script from "./WebChat.vue?vue&type=script&lang=js"
export * from "./WebChat.vue?vue&type=script&lang=js"
import style0 from "../../assets/styles/chat.css?vue&type=style&index=0&id=58d52c41&prod&lang=css&scoped=true&external"
import style1 from "./WebChat.vue?vue&type=style&index=1&id=58d52c41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d52c41",
  null
  
)

export default component.exports